export default {
  path: "/SectionContent/RoadwayDetails",
  name: "Roadway Details",
  htmlContent: "roadway_details.html",
  headings: [
    { id: "n61TrafficWayFlow", text: "61. Traffic Way Flow", type: "field" },
    { id: "n62RoadComposition", text: "62. Road Composition", type: "field" },
    { id: "n63RoadCharacter", text: "63. Road Character", type: "field" },
    { id: "n64NumberOfLanes", text: "64. Number of Lanes", type: "field" },
    { id: "n65PostedSpeed", text: "65. Posted Speed", type: "field" },
    { id: "n66WorkZone", text: "66. Work Zone", type: "field" },
    { id: "n67TrafficControl", text: "67. Traffic Control", type: "field" },
    { id: "n68DeviceInoperative", text: "68. Device Inoperative", type: "field" },
  ],
};
